import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerContent}>
                <div className={styles.footerLeft}>
                    <span className={styles.footerText}>
                        © {new Date().getFullYear()}{' '}
                        <a
                            href="https://ecomtechbd.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.footerLink}
                        >
                            Ecom Tech
                        </a>
                    </span>
                </div>

                <div className={styles.footerRight}>
                    <a
                        href="https://ecomtechbd.com/help"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                    >
                        Help
                    </a>
                    <a
                        href="https://ecomtechbd.com/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                    >
                        Privacy
                    </a>
                    <a
                        href="https://ecomtechbd.com/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                    >
                        Terms
                    </a>
                    <a
                        href="https://wa.me/+8801711026578"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                    >
                        Support
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
